import { pages } from "./lazyPages";

const { profile, address, payments, orders, loyalty, giftCards } = pages;

export const privateRoutes = [
  { path: "/profile", element: <profile.Component /> },
  { path: "/address", element: <address.Component /> },
  { path: "/payments", element: <payments.Component /> },
  { path: "/orders", element: <orders.Component /> },
  { path: "/loyalty-points", element: <loyalty.Component /> },
  { path: "/gift-cards", element: <giftCards.Component /> },
];
